@if (quoteRequestForm) {
  <ng-container [formGroup]="quoteRequestForm">
    <div formGroupName="additional_questions">
      <div class="cipx-form-form-group" *ngFor="let question of questions()">
        @if (quoteRequestForm.get('additional_questions.' + question.question_code)) {
          @if (
            question.validation?.validation_rule !== 'explainerquestion' ||
            quoteRequestForm.get('additional_questions.' + question.validation?.arguments?.[0]?.question_code)?.value
          ) {
            @switch (getStandardizedQuestionType(question)) {
            @case('string') {
              <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
                @if(!question.question_text || question.question_text.length === 0) {
                  <mat-label>{{ question.question_label }}</mat-label>
                } @else {
                  <mat-label>{{ question.question_text }}</mat-label>
                }
                <input
                  matInput
                  [formControlName]="question.question_code"
                  [placeholder]="question.question_placeholder" />
                @if (question.question_help_text) {
                  <mat-hint>{{ question.question_help_text }}</mat-hint>
                }
                @if (quoteRequestForm.get('additional_questions.' + question.question_code)?.invalid) {
                  <mat-error>{{ this.getQuestionErrorText(question) }}</mat-error>
                }
              </mat-form-field>
            }
            <!-- Note: This case now handles both 'number' and 'integer' -->
            @case('number') {
              <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
                @if(!question.question_text || question.question_text.length === 0) {
                  <mat-label>{{ question.question_label }}</mat-label>
                } @else {
                  <mat-label>{{ question.question_text }}</mat-label>
                }
                <input
                  matInput
                  type="number"
                  [formControlName]="question.question_code"
                  [placeholder]="question.question_placeholder" />
                @if (question.question_help_text) {
                  <mat-hint>{{ question.question_help_text }}</mat-hint>
                }
                @if (quoteRequestForm.get('additional_questions.' + question.question_code)?.invalid) {
                  <mat-error>{{ this.getQuestionErrorText(question) }}</mat-error>
                }
              </mat-form-field>
            }
            @case('bool') {
              @if(!question.question_text || question.question_text.length === 0) {
                <label class="cipx-form-label">{{ question.question_label }}</label>
              } @else {
                <label class="cipx-form-label">{{ question.question_text }}</label>
              }
              <mat-button-toggle-group
                [formControlName]="question.question_code"
                [attr.aria-label]="question.question_text">
                <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                <mat-button-toggle [value]="false">No</mat-button-toggle>
              </mat-button-toggle-group>
              @if (quoteRequestForm.get('additional_questions.' + question.question_code)?.invalid) {
                <mat-error>{{ this.getQuestionErrorText(question) }}</mat-error>
              }
            }
            @case('user_selected_option') {
              <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
                @if(!question.question_text || question.question_text.length === 0) {
                  <mat-label>{{ question.question_label }}</mat-label>
                } @else {
                  <mat-label>{{ question.question_text }}</mat-label>
                }
                <mat-select [formControlName]="question.question_code" [attr.aria-label]="question.question_text">
                  @if (question.user_selected_options?.placeholder) {
                    <mat-option [value]="null" disabled>{{ question.user_selected_options?.placeholder }}</mat-option>
                  }
                  <mat-option *ngFor="let opt of question.user_selected_options?.options" [value]="opt">
                    {{ opt }}
                  </mat-option>
                </mat-select>
                @if (question.question_help_text) {
                  <mat-hint>{{ question.question_help_text }}</mat-hint>
                }
                @if (quoteRequestForm.get('additional_questions.' + question.question_code)?.invalid) {
                  <mat-error>{{ this.getQuestionErrorText(question) }}</mat-error>
                }
              </mat-form-field>
            }
            @default {
              <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
                @if(!question.question_text || question.question_text.length === 0) {
                  <mat-label>{{ question.question_label }}</mat-label>
                } @else {
                <mat-label>{{ question.question_text }}</mat-label>
                }
                <input
                  matInput
                  [formControlName]="question.question_code"
                  [placeholder]="question.question_placeholder" />
                @if (question.question_help_text) {
                  <mat-hint>{{ question.question_help_text }}</mat-hint>
                }
                @if (quoteRequestForm.get('additional_questions.' + question.question_code)?.invalid) {
                  <mat-error>{{ this.getQuestionErrorText(question) }}</mat-error>
                }
              </mat-form-field>
            }
          }
        }
        }
      </div>
    </div>
  </ng-container>
}
